import { useState, ChangeEventHandler } from "react";
import { Dialog } from "@mui/material";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { FadeTransition } from "common/elements";
import I18n from "features/parent/i18n";
import { Course } from "features/courses/types";
import { string2Course } from "features/courses/utils";

// コースごとのステージの数（レベルはどちらも 7）
const STAGE_COUNT: { [course: string]: number } = {
  [Course.ALGORITHM]: 6,
  [Course.PROGRAM]: 7,
};

export const CourseAnswer = () => {
  const play = usePlaySound();
  const [step, setStep] = useState(1);
  const [stage, setStage] = useState(1);
  const [modal, setModal] = useState(false);
  const [course, setCourse] = useState(Course.ALGORITHM);
  const handleChangeCourse: ChangeEventHandler<HTMLSelectElement> = (e) => {
    play();
    setCourse(string2Course(e.target.value));
    setStage(1);
    setStep(1);
  };
  const handleChangeStage: ChangeEventHandler<HTMLSelectElement> = (e) => {
    play();
    setStage(Number(e.target.value));
  };
  const handleChangeStep: ChangeEventHandler<HTMLSelectElement> = (e) => {
    play();
    setStep(Number(e.target.value));
  };
  const handleModal = (show: boolean) => () => {
    play();
    setModal(show);
  };

  return (
    <>
      <Dialog
        fullScreen
        maxWidth={false}
        open={modal}
        sx={{ zIndex: 200000 }}
        TransitionComponent={FadeTransition}
        PaperProps={{ style: { backgroundColor: "transparent" } }}
        transitionDuration={{ enter: 1000, exit: 500 }}
      >
        <div
          className="flex-col-center w-full h-full bg-textcolor-black/60"
          onClick={handleModal(false)}
        >
          <img
            alt="コースの正解のブロックの組み方の拡大表示"
            src={`${Constants.assetHost}/assets/${course}/answer/stage${stage}/step${step}.png`}
            className="border-solid border-[4px] border-outline rounded-[12px] p-[20px] bg-white "
          />
        </div>
      </Dialog>
      <div className="flex-col-view items-center !flex-1 w-full mt-12 gap-4">
        <div className="flex-row-el items-center gap-2">
          <label className="text-[24px] text-textcolor-black">
            {I18n.t("MSG_SETTING_COURSE_ANSWER_COURSE_TITLE")}
          </label>
          <select
            value={course}
            onChange={handleChangeCourse}
            className="cursor-pointer min-w-[280px] px-3 py-2 bg-white rounded-[8px] border border-gray2-60 text-[24px] text-textcolor-black"
          >
            <option value={Course.ALGORITHM}>{I18n.t("MSG_COURSE_ALGORITHM")}</option>
            <option value={Course.PROGRAM}>{I18n.t("MSG_COURSE_PROGRAM")}</option>
          </select>
        </div>

        <div className="flex-row-el w-full items-start gap-6">
          <div className="flex-col-el gap-4 items-start shrink-0">
            <div className="flex-row-el items-center gap-2">
              <label className="text-[24px] text-textcolor-black w-[180px] text-right">
                {I18n.t("MSG_SETTING_COURSE_ANSWER_STAGE_TITLE")}
              </label>
              <select
                value={stage}
                onChange={handleChangeStage}
                className="cursor-pointer min-w-[180px] px-3 py-2 bg-white rounded-[8px] border border-gray2-60 text-[24px] text-textcolor-black"
              >
                {Array(STAGE_COUNT[course])
                  .fill(0)
                  .map((value, index) => (
                    <option key={index} value={index + 1}>
                      {I18n.t("MSG_SETTING_COURSE_ANSWER_STAGE")} {index + 1}
                    </option>
                  ))}
              </select>
            </div>

            <div className="flex-row-el items-center gap-2">
              <label className="text-[24px] text-textcolor-black w-[180px] text-right">
                {I18n.t("MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE")}
              </label>
              <select
                value={step}
                onChange={handleChangeStep}
                className="cursor-pointer min-w-[180px] px-3 py-2 bg-white rounded-[8px] border border-gray2-60 text-[24px] text-textcolor-black"
              >
                {Array(7)
                  .fill(0)
                  .map((value, index) => (
                    <option key={index} value={index + 1}>
                      {I18n.t("MSG_SETTING_COURSE_ANSWER_LEVEL")} {index + 1}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div
            className="flex-col-el cursor-pointer flex-1 min-w-0 max-w-[460px] items-center"
            onClick={handleModal(true)}
          >
            <img
              alt="コースの正解のブロックの組み方"
              src={`${Constants.assetHost}/assets/${course}/answer/stage${stage}/step${step}.png`}
              className="box-border max-w-full h-auto border-solid rounded-xl border-[4px] border-outline p-6 bg-white"
            />
          </div>
        </div>
      </div>
    </>
  );
};
